export default __webpack_public_path__ + "static/wvex1-5b34224dd01e66391ca4f634c4a1a27c.jpg";